import { useState, useCallback } from 'react';
import { cepService } from '../services/cepService';

export const useCep = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [addressData, setAddressData] = useState(null);

  const searchCep = useCallback(async (cep) => {
    if (!cep || !cepService.isValidCep(cep)) {
      setError('CEP inválido');
      setAddressData(null);
      return null;
    }

    setLoading(true);
    setError(null);

    try {
      const data = await cepService.getAddressByCep(cep);
      setAddressData(data);
      setError(null);
      return data;
    } catch (err) {
      setError(err.message);
      setAddressData(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const clearCep = useCallback(() => {
    setAddressData(null);
    setError(null);
    setLoading(false);
  }, []);

  return {
    searchCep,
    clearCep,
    loading,
    error,
    addressData,
    formatCep: cepService.formatCep,
    isValidCep: cepService.isValidCep
  };
};
